import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../shared';

// ag-grid
import {AgGridModule} from '@ag-grid-community/angular';

import { USERS_FINANTIAL_STATUS_REPORT_ROUTE, LessonsByInstructorReportComponent } from './';

@NgModule({
    imports: [
        JYoguiSharedModule,
        AgGridModule.withComponents([]),
        RouterModule.forRoot([USERS_FINANTIAL_STATUS_REPORT_ROUTE], { useHash: true })
    ],
    declarations: [
        LessonsByInstructorReportComponent,
    ],
    entryComponents: [
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiLessonsByInstructorReportModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/lessons-by-instructor-report/lessons-by-instructor-report-component.module.ts